import useSWR from "swr";

type RatingData = {
  rating: number;
  date: string;
}[];

export const useFetchGoogleRatings = (restaurantId?: string, requestQueryParams?: string) => {
  const fetcherKey = restaurantId ? `/external_api/restaurants/${restaurantId}/google/ratings/${requestQueryParams}` : null;

  // ログをここに追加
  if (fetcherKey) {
    console.log("📡 useSWR fetcherKey:", fetcherKey);
  }

  const { data: ratingData, error, isLoading } = useSWR<RatingData>(fetcherKey);

  // エラーの内容も表示
  if (error) {
    console.error("❌ useSWR error in useFetchGoogleRatings:", error);
  }

  return { ratingData, isLoading, error };
};